<template>

  <div class="pt-2">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>Opisz kim jesteś i czym się zajmujesz:</label>

              <b-input-group>

                <b-form-input v-model="kim_jestem" size="lg" ref="kim_jestem" placeholder="np. Jestem Jan Kowalski i zajmuję się grafiką do social media"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">

              <label>Opisz firmę, do której aplikujesz o zlecenia:</label>

              <b-input-group>

                <b-form-input v-model="opis_firmy" size="lg" ref="opis_firmy" placeholder="np. Sklep internetowy z zabawkami"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Wpisz jakie zlecenie chcesz wykonać:</label>

              <b-input-group>

                <b-form-input v-model="jakie_uslugi" size="lg" ref="jakie_uslugi" placeholder="np. chciałbym zaproponować wam usługę tworzenia grafiki do social media dla Waszej firmy"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Opisz co może poprawić firma, jeżeli zleci Ci tworzenie grafik lub wideo:</label>

              <b-input-group>

                <b-form-input v-model="co_poprawic" size="lg" ref="co_poprawic" placeholder="np. częstotliwość publikowania postów"></b-form-input>

              </b-input-group>

            </div>

          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Generuj e-mail
          </b-button>

        </b-col>

      </b-row>



      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje e-mail <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowany e-mail</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">

            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>

        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'AppFreelanceGraphicAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      selectedText: '',
      query: "",
      kim_jestem: "",
      opis_firmy: "",
      jakie_uslugi: "",
      co_poprawic: "",
      finishContent: '',
      selectedSchema: null
    }
  },
  methods: {

    generateFinish: function() {

      if(!this.kim_jestem) return false;
      if(!this.opis_firmy) return false;
      if(!this.jakie_uslugi) return false;
      if(!this.co_poprawic) return false;


      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""

      var query = "";



      query = "Napisz mail w stylu cold mailing w którym przekonasz firmę do rozpoczęcia współpracy ze mną jako z  " + this.kim_jestem + ". Firma, do której aplikuję to " + this.opis_firmy + ". Zwróć uwagę w emailu na korzyści ze współpracy ze mną jako specjalistą i wypisz w punktach listę korzyści (po jednym, krótkim zdaniu) ze współpracy. Chcę zaproponować tej firmie usługi " + this.jakie_uslugi + ". Wiem, że firmie można poprawić " + this.co_poprawic + ".";

      var doneText = "";

      this.axios.post(window.API_URL + "text/generateFromAI/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {

        let data = response.data

        if(data.redirectTo) {

          top.location.href = data.redirectTo;

        }

        doneText = data.result;

        this.finishContent = doneText;

        this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

        this.$refs.generatePost.disabled = false
        this.generatedPostTitle = "Wygenerowany e-mail"

      }).catch(function() {

        this.$refs.generatePost.disabled = false

      })



    },

    copyResults: function() {

      this.$refs.finishContent.style.display = "block";

      this.$refs.finishContent.focus();

      document.execCommand('copy');

      this.$refs.finishContent.style.display = "none"

      window.scrollTo(0, 0)

      this.$bvToast.toast('Treść została skopiowana do schowka', {
        title: 'Skopiowano',
        autoHideDelay: 5000,
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })

    }

  },
  computed: {

  },
  created() {

    this.$watch('finishContent', (value) => {

      var lines = value.split(/\r|\r\n|\n/);

      this.finishLinesCount = lines.length;

    })

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>